import React, { useState, useEffect, useRef } from "react";
import "../style.scss";
import "./style.scss";
import { Helmet } from "react-helmet";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import {
  getYoutubePosterImage,
  getRouting,
  formDataGenerator,
  getLang,
} from "../../../../../utils/common";
import { Link, BrowserRouter as Router, Route } from "react-router-dom";
import { cornerVideoApi, cornerSectionOverview } from "../actions";
import "react-tabs/style/react-tabs.scss";
import { event } from "react-ga";
import PaginationComponent from "../../../general/PaginationComponent";

const Videos = (props) => {
  const {
    cornerVideoApi,
    cornerVideoListData,
    cornerSectionOverview,
    cornerOverviewList,
    location: { pathname },
  } = props;
  const [cornerOverviewTab, setcornerOverviewTab] = useState("");
  const [videoData, setvideoData] = useState();
  const [searchFilter, setsearchFilter] = useState("");
  const [metaData, setMetaData] = useState("");
  const [flag, setFlag] = useState(false);
  const [totalRecords, setTotalRecords] = useState(0);
  const [activePage, setActivePage] = useState(1);
  const [limit, setLimit] = useState(9);

  const getPaginatedData = (page) => {
    loadData(page);
  };

  const loadData = async (page) => {
    let formData = {
      search: searchFilter ? searchFilter : "",
      limit: limit,
      offset: limit * (page - 1),
    };
    await cornerVideoApi(formDataGenerator(formData));
    let unit = window.innerHeight / 100;
    window.scrollTo({ top: 40 * unit });
  };


  useEffect(()=>{
    if(flag == true){
      setFlag(false);
    }
  },[flag]);

  useEffect(() => {
    let params = {
      search: searchFilter ? searchFilter : "",
      limit: limit,
      offset: 0,
    };
    !(cornerVideoListData && cornerVideoListData.cornerVideo) && cornerVideoApi(formDataGenerator(params));
  }, []);
  useEffect(() => {
    let params = {
      search: searchFilter ? searchFilter : "",
      limit: limit,
      offset: 0,
    };
    flag == true && cornerVideoApi(formDataGenerator(params));
  }, [searchFilter]);

  useEffect(() => {
    if (
      cornerVideoListData &&
      cornerVideoListData.cornerVideo &&
      cornerVideoListData.cornerVideo.videos
    ) {
      setvideoData(cornerVideoListData.cornerVideo.videos);
    }
    else{
      setvideoData([]);
    }
    if (
      cornerVideoListData &&
      cornerVideoListData.cornerVideo &&
      cornerVideoListData.cornerVideo.meta
    ) {
      setMetaData(cornerVideoListData.cornerVideo.meta);
    }
    if (
      cornerVideoListData &&
      cornerVideoListData.cornerVideo &&
      cornerVideoListData.cornerVideo.count
    ) {
      setTotalRecords(cornerVideoListData.cornerVideo.count);
    }

  }, [cornerVideoListData]);

  useEffect(() => {
    !(cornerOverviewList && cornerOverviewList.cornerOverview) && cornerSectionOverview();
  }, []);

  useEffect(() => {
    if (cornerOverviewList && cornerOverviewList.cornerOverview) {
      setcornerOverviewTab(cornerOverviewList.cornerOverview);
    }
  }, [cornerOverviewList]);

  const handleInputSearchName = (e) => {
    setsearchFilter(e.target.value);
    setFlag(true);
  };

  //dropdown start

  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  const toggleDropDown = () => {
    setIsOpen(!isOpen);
  };

  const handleClickOut = (event) => {
    if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
      setIsOpen(false);
    }
  };

  useEffect(() => {
    document.addEventListener("click", handleClickOut);
    return () => {
      document.removeEventListener("click", handleClickOut);
    };
  }, [isOpen]);

  //dropdown end
  return (
    <>
      <div className="wrapper">
        {metaData && metaData !== null && <Helmet>
          <title>{metaData.title ? metaData.title : ""}</title>
          <meta name="description" content={metaData.description ? metaData.description : ""} />
          <meta property="og:title" content={metaData.og_title ? metaData.og_title : ""} />
          <meta property="og:description" content={metaData.og_description ? metaData.og_description : ""} />
          <meta property="og:image" content={metaData.og_image ? metaData.og_image : ""} />
          <meta property="og:url" content={metaData.og_url ? metaData.og_url : ""} />
        </Helmet>}
        <section className="aboutHead">
          <div className="container">
            <div className="d-flex dropdowncls">
              <div class="dropdown me-auto" ref={dropdownRef}>
                <div
                  id="dropdownMenuLink"
                  // data-bs-toggle="dropdown"
                  // aria-expanded="false"
                  onClick={toggleDropDown}
                >
                  <h1>
                    <span>Videos</span>
                    <img
                      className="ms-2"
                      src="/images/New/redDownArrow.svg"
                      alt=""
                    />
                  </h1>
                </div>
                {isOpen && (
                  <ul
                    class="dropdown-body"
                    aria-labelledby="dropdownMenuLink"
                  >
                    {cornerOverviewTab &&
                      cornerOverviewTab.length > 0 &&
                      cornerOverviewTab.map((over, index) =>
                        over.linkName != "Videos" ? (
                          <li>
                            <a
                              class="dropdown-item fw-bold"
                              href={over.linkName=='Quiz' ? over.linkUrl : over.routeConstant}
                            >
                              {over.linkName}
                            </a>
                          </li>
                        ) : null
                      )}
                  </ul>
                )}
              </div>
              <nav
                aria-label="breadcrumb"
                className="align-self-center breadCrumbCust d-md-inlin"
              >
                <ol className="breadcrumb mb-0">
                  <li className="breadcrumb-item">
                    <Link to={getRouting(`/`)}>Home</Link>
                  </li>
                  <li className="breadcrumb-item">
                    <Link to={getRouting(`/learners-corner`)}>
                      Learners’ Corner
                    </Link>
                  </li>

                  {/* <li
                    className="breadcrumb-item active breadcolor"
                    aria-current="page"
                  >
                    Videos
                  </li> */}
                </ol>
              </nav>
            </div>
          </div>
        </section>
        <section>
          <div className="container">
            <div className="learnerscorner mt-5">
              <div className="row mb-4">
                <div className="col-md-5">
                  <div className="row">
                    <div className="col-md-8">
                      <div className="input-group mb-4 inputsearch">
                        <span className="input-group-text" id="basic-addon2">
                          <img src="/images/New/grey-search.svg" />
                        </span>
                        <input
                          type="text"
                          className="form-control ps-0"
                          placeholder="Search..."
                          aria-label="Search..."
                          aria-describedby="basic-addon2"
                          onChange={handleInputSearchName}
                          value={searchFilter}
                        />
                        
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="row">
                {videoData &&
                  videoData.length > 0 &&
                  videoData.map((item) => {
                    const posterImage = getYoutubePosterImage(item.youtubeid);
                    return (
                      <div className="col-md-4 mb-4">
                        <div className="card">
                          <a href={`/learners-corner/${pathname.split("/")[2]}/${
                                item.suggestedUrl
                              }`}
                          >
                            <div className="mainvideo">
                              {!posterImage ? (
                                <img
                                  src="/images/New/learnNew/video.svg" alt="videoimg"
                                />
                              ) : (
                                <img src={posterImage} className="posterimg img-fluid w-100" alt="videoimg" />
                              )}
                              <img
                                src="/images/New/learnNew/you-tube-play-icon.png"
                                className="playicon"
                                alt="playicon"
                              />
                              {item.youtube_duration ? (
                                <div className="readcls">
                                  {item.youtube_duration}
                                </div>
                              ) : (
                                ""
                              )}
                            </div>
                          </a>
                          <div className="card-body mt-3 p-0">
                            <a href={`/learners-corner/${pathname.split("/")[2]}/${
                                  item.suggestedUrl
                                }`}
                            >
                              <h5 className="card-title mb-0 mt-0">
                                {item.youtubeVideoTitle
                                  ? item.youtubeVideoTitle
                                  : ""}
                              </h5>
                            </a>
                            <p className="card-text">
                              {item.youtube_desc ? item.youtube_desc : ""}
                            </p>
                          </div>
                        </div>
                        {/* <Card>
                          <Link
                            to={getRouting(
                              `/learners-corner/${pathname.split("/")[2]}/${
                                item.suggestedUrl
                              }`
                            )}
                          >
                            <div className="mainvideo">
                              {!posterImage ? (
                                <Card.Img
                                  variant="top"
                                  src="/images/New/learnNew/video.svg"
                                />
                              ) : (
                                <Card.Img variant="top" src={posterImage} />
                              )}
                              <img
                                src="/images/New/learnNew/you-tube-play-icon.png"
                                className="playicon"
                              />
                              {item.youtube_duration ? (
                                <div className="readcls">
                                  {item.youtube_duration}
                                </div>
                              ) : (
                                ""
                              )}
                            </div>
                          </Link>
                          <Card.Body className="px-0">
                            <Link
                              to={getRouting(
                                `/learners-corner/${pathname.split("/")[2]}/${
                                  item.suggestedUrl
                                }`
                              )}
                            >
                              <Card.Title className="mb-0">
                                {item.youtubeVideoTitle
                                  ? item.youtubeVideoTitle
                                  : ""}
                              </Card.Title>
                            </Link>
                            <Card.Text>
                              {item.youtube_desc ? item.youtube_desc : ""}
                            </Card.Text>
                          </Card.Body>
                        </Card> */}
                      </div>
                    );
                  })}
              </div>
            </div>
          </div>
          {totalRecords > 9 && (
            <div className="row">
              <div className="col-md-12 px-3">
                <div className="paginate d-flex justify-content-center">
                  <PaginationComponent
                    totalRecords={totalRecords}
                    activePage={activePage}
                    setActivePage={setActivePage}
                    limit={limit}
                    getPaginatedData={getPaginatedData}
                    itemsCountPerPage={limit}
                  />
                </div>
              </div>
            </div>
          )}
        </section>
      </div>
    </>
  );
};

const mapStateToProps = (state) => ({
  cornerVideoListData: state.LearnsCorners,
  cornerOverviewList: state.LearnsCorners,
});

const mapDispatchToProps = (dispatch) => ({
  cornerVideoApi: bindActionCreators(cornerVideoApi, dispatch),
  cornerSectionOverview: bindActionCreators(cornerSectionOverview, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(Videos);
